import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProjectState {
    id: string,
    name: string,
    isLoop: boolean,
    getExportAPIURL: string,
    getExportAPIKey: string,
    getLastRunDate: string,
    getDateOfCreation: string,
    isThereBlockExpanded: boolean,
    globalConnections: { [connectionType: string]: string },
    globalGoogleSpreadsheet?: { spreadsheet_id: string, spreadsheet_name?: string }
}

const initialState: ProjectState = {
    id: '',
    name: '',
    isLoop: false,
    getExportAPIURL: '',
    getExportAPIKey: '',
    getLastRunDate: '',
    getDateOfCreation: '',
    isThereBlockExpanded: false,
    globalConnections: {}
}

export const projectSlice = createSlice({
    name: 'project',
    initialState,
    reducers: {
        setProjectData: (state, action: PayloadAction<Partial<ProjectState>>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setProjectData } = projectSlice.actions;
export default projectSlice.reducer;